import {
  addNodeUnderParent,
  changeNodeAtPath,
  find,
  removeNode,
  // @ts-expect-error TS(7016): Could not find a declaration file ...
} from "@nosferatu500/react-sortable-tree"

/**
 * React-sortable-tree utils documentation
 * https://github.com/frontend-collective/react-sortable-tree/blob/master/src/utils/tree-data-utils.js
 */

const getNodeKey = ({ node }: $TSMigrationFixMe) => node?.id

export const findNode = ({ categorias, id }: $TSMigrationFixMe) => {
  const nodesFound = find({
    getNodeKey,
    treeData: categorias,
    searchMethod: ({ node }: $TSMigrationFixMe) => {
      return node?.id === id
    },
    searchFocusOffset: 0,
  })
  return nodesFound?.matches?.[0]
}

export const addNode = ({
  categorias,
  parentId,
  newNode,
}: $TSMigrationFixMe) => {
  const categoriasUpdated = addNodeUnderParent({
    newNode,
    treeData: categorias,
    parentKey: parentId,
    getNodeKey,
  })
  return categoriasUpdated
}

export const deleteNode = ({ categorias, path }: $TSMigrationFixMe) => {
  const newCategoriasTree = removeNode({
    getNodeKey,
    treeData: categorias,
    path,
  })
  return newCategoriasTree
}

export const modifyNode = ({ categorias, newNode, id }: $TSMigrationFixMe) => {
  const node = findNode({ categorias, id })

  const categoriasWithRemovedNode = deleteNode({
    categorias,
    path: node?.path,
  })

  const categoriasWithAddedNode = addNode({
    categorias: categoriasWithRemovedNode?.treeData,
    parentId: newNode?.categoriaPadreId,
    newNode,
  })

  return categoriasWithAddedNode
}

export const changeNode = ({ categorias, id, newNode }: $TSMigrationFixMe) => {
  const { path } = findNode({ categorias, id })

  const newCategorias = changeNodeAtPath({
    treeData: categorias,
    path,
    newNode,
    getNodeKey,
  })

  return newCategorias
}

export const selectAllDescendentNodes = ({
  node,
  isSelected,
}: $TSMigrationFixMe) => {
  node.isSelected = isSelected
  node.children?.forEach((nodeToExplore: $TSMigrationFixMe) => {
    selectAllDescendentNodes({ node: nodeToExplore, isSelected })
  })
}

const exploreCategorias = (
  categoria: $TSMigrationFixMe,
  callback: $TSMigrationFixMe
) => {
  const children = categoria.children || categoria.subCategorias
  callback?.(categoria)
  children.forEach((explore: $TSMigrationFixMe) =>
    exploreCategorias(explore, callback)
  )
}

export const getAllDescendentCategorias = (categoria: $TSMigrationFixMe) => {
  const categoriasId: $TSMigrationFixMe = []

  exploreCategorias(categoria, ({ title, nombre, id }: $TSMigrationFixMe) => {
    categoriasId.push({ nombre: nombre || title, id })
  })

  return categoriasId
}
